import {
  faTachometerAlt,
  faServer,
  faBook,
  faGear,
  faFlag,
  faTrophy,
  faUser,
  faChartLine,
  faMedal,
  faClock,
  faDatabase,
  faShieldAlt,
  faCode,
  faTools,
} from '@fortawesome/free-solid-svg-icons';

export const navItems = [
  { id: 'dashboard', title: 'Dashboard', icon: faTachometerAlt },
  { id: 'labs', title: 'Labs', icon: faServer },
  { id: 'courses', title: 'Courses', icon: faBook },
  { id: 'challenges', title: 'Challenges', icon: faFlag },
  { id: 'achievements', title: 'Achievements', icon: faTrophy },
  { id: 'leaderboard', title: 'Leaderboard', icon: faChartLine },
  { id: 'profile', title: 'Profile', icon: faGear },
];

export const userData = {
  stats: [
    {
      title: 'Rooms Completed',
      value: 15,
      change: '67% completion rate',
      icon: faServer,
      color: 'var(--purple)',
      bg: 'var(--purple-subtle)',
    },
    {
      title: 'Challenges Solved',
      value: 42,
      change: '+5 this week',
      icon: faFlag,
      color: 'var(--danger)',
      bg: 'var(--danger-subtle)',
    },
    {
      title: 'Badges Earned',
      value: 7,
      change: '+1 Earned',
      icon: faTrophy,
      color: 'var(--bronze)',
      bg: 'var(--bronze-subtle)',
    },
    {
      title: 'Hours Hacked',
      value: 156,
      change: '+12 this week',
      icon: faClock,
      color: 'var(--main-color)',
      bg: 'var(--main-subtle)',
    },
    {
      title: 'Contents Enrolled',
      value: 12,
      change: '+2 Enrolled',
      icon: faBook,
      color: 'var(--orange)',
      bg: 'var(--orange-subtle)',
    },
    {
      title: 'Certificates',
      value: 5,
      change: '+1 earned',
      icon: faMedal,
      color: 'var(--green)',
      bg: 'var(--green-subtle)',
    },
  ],
  labs: [
    {
      name: 'Login Bypass Lab (SQL Injection)',
      progress: 60,
      flags: '3/5',
      status: 'Deployed',
    },
    { name: 'Web Vuln Machine', progress: 30, flags: '1/6', status: 'Ready' },
    { name: 'XSS Attack Lab', progress: 80, flags: '4/4', status: 'Deployed' },
    {
      name: 'Buffer Overflow Challenge',
      progress: 10,
      flags: '0/3',
      status: 'Ready',
    },
    {
      name: 'Privilege Escalation Lab',
      progress: 50,
      flags: '2/4',
      status: 'Deployed',
    },
  ],
  courses: [
    {
      name: 'XSS Fundamentals',
      progress: 75,
      icon: faCode,
      color: 'linear-gradient(90deg,#f97316,#ef4444)',
    },
    {
      name: 'Access Control Vulnerabilities',
      progress: 45,
      icon: faShieldAlt,
      color: 'linear-gradient(90deg,#facc15,#fb923c)',
    },
    {
      name: 'SQL Injection Mastery',
      progress: 20,
      icon: faDatabase,
      color: 'linear-gradient(90deg,#3b82f6,#06b6d4)',
    },
    {
      name: 'Burp Suite Essentials',
      progress: 10,
      icon: faTools,
      color: 'linear-gradient(90deg,#10b981,#14b8a6)',
    },
    {
      name: 'WireShark Essentials',
      progress: 10,
      icon: faTools,
      color: 'linear-gradient(90deg,#10b981,#14b8a6)',
    },
  ],
  achievements: [
    {
      name: 'Cybersecurity Enthusiast',
      description: 'Joined CyberLabs Platform',
      date: '1 month ago',
      color: 'linear-gradient(90deg,#6b7280,#374151)',
    },
    {
      name: 'SQL Injection Expert',
      description: 'Completed SQL Injection Course',
      date: '2 days ago',
      color: 'linear-gradient(90deg,#f59e0b,#ef4444)',
    },
    {
      name: 'XSS Specialist',
      description: 'Mastered Cross-Site Scripting',
      date: '1 week ago',
      color: 'linear-gradient(90deg,#10b981,#06b6d4)',
    },
    {
      name: 'Fast Learner',
      description: 'Completed 5 lessons in one day',
      date: '3 days ago',
      color: 'linear-gradient(90deg,#fbbf24,#f97316)',
    },
    {
      name: 'Bug Bounty Hunter',
      description: 'Reported 10 valid vulnerabilities',
      date: '2 weeks ago',
      color: 'linear-gradient(90deg,#3b82f6,#6366f1)',
    },
  ],
  streak: 15,
  level: { current: 'Intermediate Hacker', xp: 2500, next: 5000 },
  deadlines: [
    {
      name: 'MCQ Quiz',
      due: '2 days',
      color: 'var(--orange)',
      bg: 'var(--orange-subtle)',
    },
    {
      name: 'Regex Challenge',
      due: '5 days',
      color: 'var(--purple)',
      bg: 'var(--purple-subtle)',
    },
    {
      name: 'Bash Scripting Challenge',
      due: '1 week',
      color: 'var(--main)',
      bg: 'var(--main-subtle)',
    },
  ],
  recommended: [
    {
      name: 'Advanced XSS Attacks',
      price: 59,
      icon: faCode,
      color: 'linear-gradient(90deg,#34d399,#3b82f6)',
    },
    {
      name: 'Mastering SQL Injection',
      price: 79,
      icon: faDatabase,
      color: 'linear-gradient(90deg,#3b82f6,#06b6d4)',
    },
    {
      name: 'Burp Suite for Beginners',
      price: 49,
      icon: faTools,
      color: 'linear-gradient(90deg,#10b981,#14b8a6)',
    },
    {
      name: 'Web Application Security',
      price: 99,
      icon: faShieldAlt,
      color: 'linear-gradient(90deg,#f59e0b,#ef4444)',
    },
    {
      name: 'Ethical Hacking Basics',
      price: 39,
      icon: faUser,
      color: 'linear-gradient(90deg,#8b5cf6,#ec4899)',
    },
  ],
  leaderboard: [
    { rank: 1, name: 'HackerPro', score: 5000, level: 'Elite' },
    { rank: 2, name: 'CyberNinja', score: 4800, level: 'Elite' },
    { rank: 3, name: 'XSSMaster', score: 4500, level: 'Advanced' },
    // { rank: 4, name: 'SQLiGuru', score: 4200, level: 'Advanced' },
    // { rank: 5, name: 'BugHunter', score: 4000, level: 'Intermediate' },
    // { rank: 6, name: 'HackOn', score: 3000, level: 'Intermediate' },
  ],
  goals: [
    { text: 'Complete SQL Injection Basics', completed: true },
    { text: 'Master SQL Injection Techniques', completed: false },
    { text: 'Finish XSS Fundamentals Course', completed: false },
    { text: 'Deploy 3 Labs', completed: false },
    { text: 'Earn 5 New Badges', completed: false },
  ],
  community: [
    { post: 'Solved SQLi challenge!', author: 'User1', time: '1h ago' },
    { post: 'Any tips for XSS attacks?', author: 'User2', time: '3h ago' },
    {
      post: 'Check out my new lab deployment.',
      author: 'User3',
      time: '5h ago',
    },
  ],
  progressCourses: [
    {
      name: 'SQL Injection',
      progress: 85,
      icon: faDatabase,
      color: 'linear-gradient(to right, orange, red)',
    },
    {
      name: 'Cross-Site Scripting (XSS)',
      progress: 60,
      icon: faCode,
      color: 'linear-gradient(to right, yellow, orange)',
    },
    {
      name: 'Burp Suite Basics',
      progress: 40,
      icon: faTools,
      color: 'linear-gradient(to right, green, teal)',
    },
    {
      name: 'Web Application Security',
      progress: 25,
      icon: faShieldAlt,
      color: 'linear-gradient(to right, blue, purple)',
    },
  ],
};
